// actions types used in doctors page are defined here
export const GET_DOCTORS_DATA = 'GET_DOCTORS_DATA';
export const GET_DOCTORS_DATA_SUCCESS = 'GET_DOCTORS_DATA_SUCCESS';
export const GET_DOCTORS_DATA_ERROR = 'GET_DOCTORS_DATA_ERROR';

export const OPEN_CLOSE_ONE_DOCTOR = 'OPEN_CLOSE_ONE_DOCTOR';

export const GET_SELECTED_DOCTOR = 'GET_SELECTED_DOCTOR';
export const GET_SELECTED_DOCTOR_SUCCESS = 'GET_SELECTED_DOCTOR_SUCCESS';
export const GET_SELECTED_DOCTOR_ERROR = 'GET_SELECTED_DOCTOR_ERROR';

export const PLACE_APPOINTMENT = 'PLACE_APPOINTMENT';
export const PLACE_APPOINTMENT_SUCCESS = 'PLACE_APPOINTMENT_SUCCESS';
export const PLACE_APPOINTMENT_ERROR = 'PLACE_APPOINTMENT_ERROR';

export const SET_FILTER = 'SET_FILTER';
